module.exports = __webpack_public_path__ + "static/media/Lima-white-copy.9d6b5182.png";